<script setup lang="ts">
import InfoCircle from '@primeicons/vue/info-circle';
import Card from 'primevue/card';
import type { V2ShipmentDetail } from '@gpx-spa/queries/src/getAccountShipmentV2';
import { formatShipmentDateTime } from '@/utils/shipment-detail-format';
import { SHIPMENT_DETAIL_TRIM } from '@/components/shipment/detail/shipment-detail-trim';
import { shipmentDetailCardPt } from '@/components/shipment/detail/shipment-detail-card-pt';
import { formatMoney } from '@/utils/format-money';

defineProps<{
  shipment: V2ShipmentDetail;
}>();

const cardPt = shipmentDetailCardPt;

function formatShipmentValue(cents: number | null | undefined): string {
  if (cents == null) return '—';
  const decimalCount = cents % 100 === 0 ? 0 : 2;
  return `$${formatMoney(cents, false, decimalCount)}`;
}
</script>

<template>
  <Card :pt="cardPt">
    <template #content>
      <div class="mb-4 flex items-center gap-2">
        <InfoCircle class="text-neutral-400" aria-hidden="true" />
        <h3
          class="text-sm font-semibold uppercase tracking-wider text-neutral-900"
        >
          Shipment Details
        </h3>
      </div>

      <dl class="space-y-3">
        <div
          v-if="!SHIPMENT_DETAIL_TRIM.shipmentMode"
          class="flex justify-between"
        >
          <dt class="text-sm text-neutral-500">Mode</dt>
          <dd class="text-sm font-medium text-neutral-900">—</dd>
        </div>
        <div class="flex justify-between">
          <dt class="text-sm text-neutral-500">Carrier</dt>
          <dd class="text-sm font-medium text-neutral-900">
            {{ shipment.carrier?.trim() || '—' }}
          </dd>
        </div>
        <div class="flex justify-between">
          <dt class="text-sm text-neutral-500">Shipment Value</dt>
          <dd class="text-sm font-medium text-neutral-900">
            {{ formatShipmentValue(shipment.asset_value) }}
          </dd>
        </div>
        <div
          v-if="!SHIPMENT_DETAIL_TRIM.assignedTeam"
          class="flex justify-between"
        >
          <dt class="text-sm text-neutral-500">Assigned Team</dt>
          <dd class="text-sm font-medium text-neutral-900">—</dd>
        </div>
        <div class="flex justify-between">
          <dt class="text-sm text-neutral-500">Created</dt>
          <dd class="text-sm font-medium text-neutral-900">
            {{ formatShipmentDateTime(shipment.created_at ?? null) }}
          </dd>
        </div>
      </dl>
    </template>
  </Card>
</template>
